module.exports = __webpack_public_path__ + "img/44.f10baf30.png";